// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import XRegExp from 'xregexp'
import { coordsDMS } from 'helpers/regex'

// used to convert values for API consumption.
const convertDMStoDD = val => {
  const c = { N: 1, E: 1, S: -1, W: -1 }
  const r = XRegExp.exec(val, coordsDMS)?.groups || null

  // parsing this value failed
  if (!r) {
    return null
  }

  const sign = c[r.suffix]
  const degrees = +r.degrees
  const minutes = +r.minutes / 60
  const seconds = +r.seconds / 3600

  return +(sign * (degrees + minutes + seconds)).toFixed(6)
}

export default convertDMStoDD
